import { RowCrudStatus } from "../../common/types";
import { Theme } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type ThemeValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
  active: boolean;
  authoring: string;
  resolved: string;
};

export type ThemeErrorsType = {
  name?: { message: string; fieldLabel: string };
  active?: { message: string; fieldLabel: string };
  authoring?: { message: string; fieldLabel: string };
  resolved?: { message: string; fieldLabel: string };
};

export function ThemeValuesInit(): ThemeValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
    active: false,
    authoring: "{}",
    resolved: "{}",
  };
}

export type ThemeType = Theme | ThemeValuesType;

export function themeDisplayId(source: Partial<Theme>, _langStore: LangStore) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getThemeValues(
  source: ThemeType,
  _langStore: LangStore,
  _duplicated: boolean = false
): ThemeValuesType {
  const entityValues = ThemeValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : themeDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  entityValues.active = source.active || false;
  entityValues.authoring = source.authoring;
  entityValues.resolved = source.resolved;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
